import { http } from '@/repositories/http'
import store from '@/store/index'
import { TaishakuTaishoSettingRepository, TaishakuTaishoSettingRepositoryImpl } from '@/repositories/keiei-joho/taishaku-taisho/taishakuTaishoSettingRepository'
import { TaishakuTaishoExportRepository, TaishakuTaishoExportRepositoryImpl } from '@/repositories/keiei-joho/taishaku-taisho/taishakuTaishoExportRepository'
import { SonekiKeisanSettingRepository, SonekiKeisanSettingRepositoryImpl } from '@/repositories/keiei-joho/soneki-keisan/sonekiKeisanSettingRepository'
import { SonekiKeisanExportRepository, SonekiKeisanExportRepositoryImpl } from '@/repositories/keiei-joho/soneki-keisan/sonekiKeisanExportRepository'
import { KeieiJokyoSettingRepository, KeieiJokyoSettingRepositoryImpl } from '@/repositories/keiei-joho/keiei-jokyo/keieiJokyoSettingRepository'
import { ShokushuSettingRepository, ShokushuSettingRepositoryImpl } from '@/repositories/keiei-joho/shokushu/shokushuSettingRepository'
import { ShokushuRegisterRepository, ShokushuRegisterRepositoryImpl } from '@/repositories/keiei-joho/shokushu/shokushuRegisterRepository'
import { KeieiJokyoRegisterRepository, KeieiJokyoRegisterRepositoryImpl } from '@/repositories/keiei-joho/keiei-jokyo/keieiJokyoRegisterRepository'
import {
  KeieiJohoExportRepository,
  KeieiJohoExportRepositoryImpl
} from '@/repositories/keiei-joho/keiei-joho/keieiJohoExportRepository'

type Repositories = {
  taishakuTaishoSetting: TaishakuTaishoSettingRepository;
  taishakuTaishoExport: TaishakuTaishoExportRepository;
  sonekiKeisanSetting: SonekiKeisanSettingRepository;
  sonekiKeisanExport: SonekiKeisanExportRepository;
  keieiJohoExport: KeieiJohoExportRepository;
  keieiJokyoSetting: KeieiJokyoSettingRepository;
  keieiJokyoRegister: KeieiJokyoRegisterRepository;
  shokushuSetting: ShokushuSettingRepository;
  shokushuRegister: ShokushuRegisterRepository;
}

const keieiJohooUri = 'keiei'

export const keieiJohoRepositories: Repositories = {
  taishakuTaishoSetting: new TaishakuTaishoSettingRepositoryImpl(http, keieiJohooUri, store.state),
  taishakuTaishoExport: new TaishakuTaishoExportRepositoryImpl(http, keieiJohooUri, store.state),
  sonekiKeisanSetting: new SonekiKeisanSettingRepositoryImpl(http, keieiJohooUri, store.state),
  sonekiKeisanExport: new SonekiKeisanExportRepositoryImpl(http, keieiJohooUri, store.state),
  keieiJohoExport: new KeieiJohoExportRepositoryImpl(http, keieiJohooUri, store.state),
  keieiJokyoSetting: new KeieiJokyoSettingRepositoryImpl(http, keieiJohooUri, store.state),
  keieiJokyoRegister: new KeieiJokyoRegisterRepositoryImpl(http, keieiJohooUri, store.state),
  shokushuSetting: new ShokushuSettingRepositoryImpl(http, keieiJohooUri, store.state),
  shokushuRegister: new ShokushuRegisterRepositoryImpl(http, keieiJohooUri, store.state)
}
